import React from "react";
import { Payment } from "./payment";
import { withTranslation } from 'react-i18next';

class PaymentParent extends React.Component {
    constructor(props) {
    super(props);
    this.state = {

    }
  }
  render() {
    return <Payment  {...this?.props}/>;
  }
}

export default withTranslation('common') (PaymentParent);
